namespace TabAurous.Purchase {
    export namespace PurchaseReturnMasterService {
        export const baseUrl = 'Purchase/PurchaseReturnMaster';

        export declare function Create(request: Serenity.SaveRequest<PurchaseReturnMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PurchaseReturnMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PurchaseReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PurchaseReturnMaster/Create",
            Update = "Purchase/PurchaseReturnMaster/Update",
            Delete = "Purchase/PurchaseReturnMaster/Delete",
            Retrieve = "Purchase/PurchaseReturnMaster/Retrieve",
            List = "Purchase/PurchaseReturnMaster/List",
            PartyList = "Purchase/PurchaseReturnMaster/PartyList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'PartyList'
        ].forEach(x => {
            (<any>PurchaseReturnMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
